"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hideVisually = _interopRequireDefault(require("../../../theming/styles/hideVisually"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Fraction = function Fraction(_ref) {
  var value = _ref.value,
      max = _ref.max,
      maxComponent = _ref.maxComponent,
      valueComponent = _ref.valueComponent,
      className = _ref.className,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["value", "max", "maxComponent", "valueComponent", "className", "onClick"]);

  var fractionArray = _toConsumableArray(Array(max)).map(function (e, index) {
    return index < value;
  });

  var unfilled = maxComponent || _react["default"].createElement(DesaturatedDot, null);

  var filled = valueComponent || _react["default"].createElement(ColoredDot, null);

  var addKey = function addKey(compo, index, handleClick) {
    return _react["default"].cloneElement(compo, {
      key: "dot-".concat(index),
      onClick: handleClick || null
    });
  };

  return _react["default"].createElement(FractionWrapper, _extends({
    className: className
  }, rest), fractionArray.map(function (dot, index) {
    return dot ? addKey(filled, index, function () {
      return onClick ? onClick(index) : null;
    }) : addKey(unfilled, index, function () {
      return onClick ? onClick(index) : null;
    });
  }), _react["default"].createElement(Hide, null, value, " / ", max));
};

var Hide = _styledComponents["default"].span.withConfig({
  displayName: "Fraction__Hide",
  componentId: "sc-1bvo4o1-0"
})(["", ";"], _hideVisually["default"]);

Fraction.themeProps = {
  wrapper: {
    name: "fraction",
    description: "Wrapper style",
    type: _themeContants.themePropTypes.style
  },
  circle: {
    name: "fraction_circle",
    description: "Circle style",
    type: _themeContants.themePropTypes.style
  },
  coloredDot: {
    name: "fraction_colored_dot",
    description: "Colored dot style",
    type: _themeContants.themePropTypes.style
  },
  desaturatedDot: {
    name: "fraction_desaturated_dot",
    description: "Desaturated dot style",
    type: _themeContants.themePropTypes.style
  }
};
var circle = (0, _styledComponents.css)(["width:12px;height:12px;border-radius:50%;", ";"], (0, _theming.applyVariants)(Fraction.themeProps.circle.name));

var ColoredDot = _styledComponents["default"].div.withConfig({
  displayName: "Fraction__ColoredDot",
  componentId: "sc-1bvo4o1-1"
})(["", ";background-color:", ";", ";"], circle, _theming.color.primary, (0, _theming.applyVariants)(Fraction.themeProps.coloredDot.name));

var DesaturatedDot = _styledComponents["default"].div.withConfig({
  displayName: "Fraction__DesaturatedDot",
  componentId: "sc-1bvo4o1-2"
})(["", ";background-color:", ";", ";"], circle, _theming.color.line, (0, _theming.applyVariants)(Fraction.themeProps.desaturatedDot.name));

var FractionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Fraction__FractionWrapper",
  componentId: "sc-1bvo4o1-3"
})(["display:flex;flex-direction:row;> *{margin-right:", ";}", ";"], _theming.spacing.tiny, (0, _theming.applyVariants)(Fraction.themeProps.wrapper.name));

Fraction.defaultProps = {
  max: 5,
  value: 5,
  maxComponent: null,
  valueComponent: null,
  className: "",
  onClick: null
};
Fraction.propTypes = {
  /**
   * Value
   */
  value: _propTypes["default"].number.isRequired,

  /**
   * Max
   */
  max: _propTypes["default"].number.isRequired,
  maxComponent: _propTypes["default"].element,
  valueComponent: _propTypes["default"].element,
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func
};
var _default = Fraction;
exports["default"] = _default;